import { Record, List, Map } from 'immutable';

const defaultValues = {
  loading: false,
  errorMessage: '',
  filters: new Map(),
  options: new Map(),
  data: new List(),
};

export default class BaseList extends Record(defaultValues, BaseList) {
  constructor(values) {
    super({
      ...values,
      filters:
        values && values.filters ? values.filters : defaultValues.filters,
      options:
        values && values.options ? values.options : defaultValues.options,
    });
  }
}

export const toEntityList = (data, Entity) => {
  let entityItems = new List();
  if (data) {
    data.forEach((value) => {
      entityItems = entityItems.push(new Entity(value));
    });
  }
  return entityItems;
};
